<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-mr-3">{{ $t('workstations') }}</div>
            <AddNewButton v-show="canModerate"
                          :label="$t('Add')"
                          :disabled="items?.length >= 20"
                          @click="addNewItem"/>
          </template>
        </Toolbar>
        <Spinner v-if="isLoading"/>
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
              {name: 'name', title: $t('Name'),sortable: false},
              {name: 'description', title: $t('Description'), sortable: false},
              {name: 'sorting', title: $t('sortOrderLabel'), sortable: true},
              {name: 'created_at', title: $t('Created'), width: '20%', sortable: true},
          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="item.id ?? index"
                :class="{'updated-item': isItemUpdated(item.id)}">
              <td>
                <span v-if="item.name">{{ item.name }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.description">{{ item.description }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td>
                <span v-if="item.sorting">{{ item.sorting }}</span>
                <i v-else class="ti-minus"/>
              </td>
              <td class="table-date-line">
                {{ formatBy(item.created_at, item.creator) }}
              </td>
              <td v-show="actionButtonsCount">
                <div class="actions">
                  <EditButton v-show="canModerate"
                              :disabled="dataTableIsLoading" @click="editItem(item)"/>
                  <DeleteButton v-show="canModerate"
                                @click="confirmItemDelete(item)"
                                :disabled="dataTableIsLoading"/>
                </div>
              </td>
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="items && items.length"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11"/>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>


        <AreaModal :visible="itemModal"
                   :item="item"
                   @update-items="updateItems"
                   @close="closeItemModal"/>

        <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                            :modalDataIsLoading="modalDataIsLoading"
                            @close="closeConfirmItemDeleteModal"
                            @delete-item="deleteItem"
                            :data="itemToDeleteData"/>
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import AreaModal from '@/pages/data_directory/components/AreaModal'
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import formatMixins from "@/mixins/formatMixins";

export default {
  mixins: [ datatableMixins, showErrorsMixins, formatMixins ],
  components: { AreaModal },
	data() {
		return {
      fieldsExpand: 'creator',
      apiLink: 'area',
      deleteItemUrl: 'area/delete',
      routePath: '/workstations',
      sort: {
        column: 'sorting',
        direction: '',
      }
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getItems()
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('areas')
      try {
        const { status, data, headers } = await httpClient({
          url: this.apiLink,
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
          },
          signal: ctrl?.signal
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        } else {
          this.items = []
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.areas === ctrl) {
          this._abortors.areas = null
        }
      }
    },
	},
  computed: {
    canModerate() {
      return this.$store.getters.isAdminOrHigher
    },
    actionButtonsCount() {
      return this.canModerate ? 2 : 0
    },
    itemToDeleteData() {
      if (!this.itemToDelete?.name) return null
      return this.itemToDelete.name
    },
  }
}
</script>
<style scoped lang="scss">
td {
  height: 44px
}
</style>